import { RouteConfig } from 'vue-router'

const ExcellentCoachRecommend = () => import('@/views/excellent-coach-recommend/Index.vue')
const ExcellentCoachCertificate = () => import('@/views/excellent-coach-recommend/Certificate.vue')

export const excellentCoachRecommendRouter: RouteConfig = {
  path: '/excellent-coach-recommend',
  name: 'excellent_coach_recommend',
  component: ExcellentCoachRecommend,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '优秀教练员推荐',
  },
}

export const excellentCoachCertificateRouter: RouteConfig = {
  path: '/excellent-coach-recommend/certificate',
  name: 'excellent_coach_recommend_certificate',
  component: ExcellentCoachCertificate,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '证书',
  },
}

export default [excellentCoachRecommendRouter, excellentCoachCertificateRouter]
